<script  >
import * as THREE from 'three';
import { reactive, toRefs, ref, computed, render, onUpdated, mounted } from 'vue'
import { scene, renderer, CSS3renderer } from './render/render.js'
import { camera, cubeCamera } from './render/camera.js'
import { backimg, envImg } from './img/textureLoad.js'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
// import glbLoad from './meshobj/glbLoad.vue'
import computerRoom from './meshobj/machineRoom.vue'
import rendersize from './data/renderConfig.json'
export default {
    mounted() {
        console.log('子组件得钩子函数');
        let Rcanvas = document.getElementById('tplay')
        // console.log(Rcanvas);

        //因为我么参考图ui数据在左边所以咱们得threejs  canvas生成画布是屏幕1.5倍并且适当偏移一定参数到左边
        let bigSize = rendersize

        const offsetR = (render) => {
            render.setSize(window.innerWidth * bigSize.xyADD, window.innerHeight * bigSize.xyADD);
            render.domElement.style.marginLeft = -window.innerWidth * bigSize.offsetx + 'px'
            render.domElement.style.marginTop = -window.innerHeight * bigSize.offsety + 'px'
            //封装修正偏移函数
        }
        offsetR(renderer)
        offsetR(CSS3renderer)




        Rcanvas.appendChild(renderer.domElement)
        scene.background = backimg
        scene.environment = envImg
        scene.fog = new THREE.Fog(0x000000, 3, 1400);
        const controls = new OrbitControls(camera, renderer.domElement);
        const control3s = new OrbitControls(camera,CSS3renderer.domElement);


        function renderScence() {

            requestAnimationFrame(renderScence)

            controls.update()
            control3s.update()
            CSS3renderer.render(scene, camera);
            renderer.render(scene, camera)

        }
        renderScence()
    },
    components: {
        computerRoom//本地注册组件
    }
}

</script>
<template>
    <div>
        <computerRoom></computerRoom>
        <div id="tplay">

        </div>
    </div>
</template>

<style scoped lang='less'>
#tplay{
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    // position: absolute;
    // top: 0px;
    // left: 0px;
    // pointer-events: none;

}

</style>
